import { render, staticRenderFns } from "./downloadIsfExcel.vue?vue&type=template&id=21ba376b&"
import script from "./downloadIsfExcel.vue?vue&type=script&lang=js&"
export * from "./downloadIsfExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports